module.exports = __webpack_public_path__ + "static/media/blackjack.188ada51.png";